import { ModalProps } from "antd/lib/modal/Modal";
import { Alert, Input, InputNumber, message, Modal, Spin } from "antd";
import Style from "./index.module.scss";
import React from "react";
import Form, { useForm } from "rc-field-form";
import FieldWithErrorHaveLabel from "../../../../../components/FieldWithErrorHaveLabel";

import useRequestFn from "../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../service/service";
import { updateStuScore } from "../../../../../service/homework";

interface Props extends ModalProps {
    onSuccess: () => void;
    studentId: number;
    paperId: number;
    score: number;
    notes: string;
}

interface FormProp {
    score: number;
    notes: string;
}

const Index = ({
    studentId,
    paperId,
    onSuccess,
    notes,
    score,
    ...props
}: Props) => {
    const [form] = useForm<FormProp>();

    const [saveAction, { loading: saveLoading }] = useRequestFn(updateStuScore);

    async function onFinish(data: FormProp) {
        try {
            await saveAction({
                studentId,
                paperId,
                ...data
            });
            await onSuccess();
            message.success("修改成功");
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            okButtonProps={{ loading: saveLoading }}
            width={600}
            title="修改分数"
            onOk={form.submit}>
            <Spin spinning={[].some(i => i)}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        <FieldWithErrorHaveLabel
                            initialValue={score}
                            require
                            rules={[
                                {
                                    required: true,
                                    message: "请填写分数"
                                }
                            ]}
                            label="分数："
                            name="score">
                            <InputNumber maxLength={1000} min={0} step={0.1} />
                        </FieldWithErrorHaveLabel>
                        <FieldWithErrorHaveLabel
                            initialValue={notes}
                            require
                            rules={[
                                {
                                    required: true,
                                    message: "请填写备注"
                                }
                            ]}
                            label="备注："
                            name="notes">
                            <Input.TextArea maxLength={100} rows={4} />
                        </FieldWithErrorHaveLabel>
                    </Form>
                    <Alert
                        message="修改分数后，原主观题分数将被锁定无法修改"
                        style={{ marginTop: 30 }}
                    />
                </div>
            </Spin>
        </Modal>
    );
};
export default Index;
